import React from "react";
import { List, ListItem, ListItemText, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import { useAuthState } from "../../Context";
import { useQuery } from "@tanstack/react-query";
import BlankPage from '../BlankPage/BlankPage';

const fetchDocuments = async (token) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/getDocuments`;
  const response = await axios.get(apiUrl, {
    headers: {
      authorizationToken: token,
    },
  });
  if (response.status !== 200) {
    throw new Error("Failed to fetch documents");
  }
  return response.data;
};

const DocumentManagement = () => {
//   const { session } = useAuthState();
//   const token = session.getIdToken().getJwtToken();

//   const { data: documents, isLoading, isError, error } = useQuery({
//     queryKey: ["DocumentsData", token],
//     queryFn: () => fetchDocuments(token),
//     refetchOnWindowFocus: false,
//   });

//   if (isLoading) {
//     return <CircularProgress />;
//   }

//   if (isError) {
//     return (
//       <Typography variant="h6" sx={{ textAlign: "center" }}>
//         Error: {error.message}
//       </Typography>
//     );
//   }

  return (
    // <List>
    //   {documents.map((document) => (
    //     <ListItem key={document.id}>
    //       <ListItemText primary={document.title} />
    //     </ListItem>
    //   ))}
    // </List>
    <BlankPage/>
  );
};

export default DocumentManagement;
